import { addDays, subYears, format } from 'date-fns'

import {
  postSchedules,
  getSchedules,
  cancelSchedule,
  putPayment,
} from '../api/bernabeu';

import {
  scheduleSlice,
  callTypes
} from "../../redux/reducers/scheduleSlice";

const { actions } = scheduleSlice;

type CreateScheduleProps = {
  service_id?: string,
  start_at?: string,
  finish_at?: string,
  metadata?: object,
  coupon_id?: string,
  payment_method?: string,
  client_card_id?: string,
  credit_id?: string,
}

const createSchedule= (field, service, start, finish, metadata = {}, couponId = null, paymentMethod = null, clientCardId = null, creditId = null) => dispatch => {
  return new Promise((resolve, reject) => {
    let params: CreateScheduleProps = {
      service_id: service,
      start_at: start,
      finish_at: finish,
      metadata: metadata,
    };

    let version = 2;

    if (couponId) {
      params.coupon_id = couponId;
    }

    if (paymentMethod) {
      params.payment_method = paymentMethod;

      if (paymentMethod == 'locally') {
        version = 1;
      }
    }

    if (clientCardId) {
      params.client_card_id = clientCardId;
    }

    if (creditId) {
      params.credit_id = creditId;
    }

    dispatch(actions.startCall({ callType: callTypes.action }));

    postSchedules(field, params, version).then((response : any) => {
      dispatch(actions.scheduleCreated());

      resolve(response);
    }).catch((error) => {
      console.log('createSchedule falhou:');
      console.log({error});

      reject(false);
    });
  });
}

const fetchSchedules = (future = true, recurrence: boolean = false, modality: any = '') => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.list }));
    let days = 365;

    let params = {
      start_at: format(new Date(), 'yyyy-MM-dd'),
      finish_at: format(addDays(new Date(), days), 'yyyy-MM-dd'),
      sort: 'start_at',
      modality: '',
      recurrence: 0,
    };

    if (!future) {
      params.start_at = format(subYears(new Date(), 5), 'yyyy-MM-dd');
      params.finish_at = format(new Date(), 'yyyy-MM-dd');
      params.sort = '-start_at';
    }

    if (modality) {
      params.modality = modality;
    }

    if (recurrence) {
      params.recurrence = recurrence === true ? 1 : 0;
    }

    getSchedules(params).then((response : any) => {
      // store.dispatch(actions.setSchedules({ status: 'completed', data: response }));
      resolve(response);
      // store.dispatch(actions.setSchedules({ status: 'completed' }));
      dispatch(actions.schedulesFetched());

    }).catch((error) => {
      console.log('fetchSchedules falhou:');
      console.log({error});

      dispatch(actions.catchError({ error, callType: callTypes.listActive }));

      reject(false);
    });
  });
}

const fetchSchedulesActive = (recurrence: boolean = false, modality) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.listActive }));

    let params = {
      start_at: format(new Date(), 'yyyy-MM-dd'),
      finish_at: format(addDays(new Date(), 30), 'yyyy-MM-dd'),
      modality: modality,
      sort: 'start_at',
      recurrence: 0,
    };

    if (recurrence) {
      params.recurrence = recurrence === true ? 1 : 0;
    }

    getSchedules(params).then((response : any) => {
      resolve(response);

      dispatch(actions.schedulesActiveFetched());
    }).catch((error) => {
      console.log('fetchSchedulesActive falhou:');
      console.log({error});

      dispatch(actions.catchError({ error, callType: callTypes.listActive }));

      reject(false);
    });
  });
}

const fetchSchedule = (id) => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.list }));

    let params = {
      id: id,
    };

    getSchedules(params).then((response : any) => {
      dispatch(actions.schedulesFetched());

      resolve(response[0]);
      // store.dispatch(actions.setSchedules({ status: 'completed' }));
    }).catch((error) => {
      console.log('fetchSchedules falhou:');
      console.log({error});

      dispatch(actions.schedulesFetched());

      reject(false);
    });
  });
}

const fetchCancelSchedule = (scheduleId, refundType = '') => dispatch => {
  return new Promise((resolve, reject) => {
    dispatch(actions.startCall({ callType: callTypes.action }));

    let params: any = {};

    if (refundType) {
      params.refund_type = refundType;
    }

    cancelSchedule(scheduleId, params).then(response => {
      dispatch(actions.scheduleCanceled());

      resolve(true);
    }).catch((error) => {
      console.log('fetchCancelSchedule falhou:');
      console.log({error});

      dispatch(actions.catchError({ error, callType: callTypes.action }));

      reject(false);
    });
  });
}

export {
  createSchedule,
  fetchSchedule,
  fetchSchedulesActive,
  fetchSchedules,
  fetchCancelSchedule
}